'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var accounts_1 = require("./accounts");

var contracts_1 = require("./contracts");

var formatters_1 = require("./formatters");

var methods_1 = require("./methods");

var extend = function extend(web3) {
  accounts_1.extendAccounts(web3);
  formatters_1.extendFormatters(web3);
  methods_1.extendMethods(web3);
  contracts_1.extendContracts(web3);
};

exports.extend = extend;